import { render, staticRenderFns } from "./cabinetProfile.vue?vue&type=template&id=feb7794c"
import script from "./cabinetProfile.vue?vue&type=script&lang=js"
export * from "./cabinetProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports